
// src/components/layout/MaintenancePage.tsx
"use client"; // Keep as client component if it needs hooks or interactivity later, though for now it's static.
              // Can be a server component if it remains purely presentational.

import React from 'react';
import { Construction } from 'lucide-react'; // Using Lucide icon

export default function MaintenancePage() {
  return (
    <div className="container mx-auto px-4 flex flex-col items-center justify-center min-h-screen py-12">
      <Construction className="h-24 w-24 text-primary mb-8 animate-pulse" />
      <h1 className="text-4xl font-bold text-foreground mb-4">
        Under Construction
      </h1>
      <p className="text-xl text-muted-foreground mb-2">
        Our site is currently undergoing scheduled maintenance and improvements.
      </p>
      <p className="text-lg text-muted-foreground">
        We'll be back shortly. Thank you for your patience!
      </p>
      {/* You could add a contact email or link if needed */}
      {/* <p className="mt-8 text-sm text-muted-foreground">
        If you need to reach us, please email <a href="mailto:support@example.com" className="underline">support@example.com</a>.
      </p> */}
    </div>
  );
}

    